import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeatureCards from './components/FeatureCards';
import CategorySection from './components/CategorySection';
import PopularArticles from './components/PopularArticles';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="Organization" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: 'http //www.17c/ 官方入口与使用指南 - 首页',
          description: 'http //www.17c/ 官方入口与使用指南，提供完整的访问指引、功能介绍与使用说明，帮助用户快速找到正确入口，了解平台核心功能、注册流程及常见问题解答。',
          url: 'https://www.17c.com/',
        }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <FeatureCards />
        <CategorySection />
        <PopularArticles />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}